export const Collections = Object.freeze({
  ApiKeys: 'api-keys',
  ApiLogs: 'api-logs',
  CancellationFeedback: 'cancellation-feedback',
  DeviceTokens: 'device-tokens',
  DiscoverySources: 'discovery-sources',
  EmailLogs: 'email-logs',
  Feed: 'feed',
  FeedUploads: 'feed-uploads',
  Galleries: 'galleries',
  Industries: 'industries',
  OperationLogs: 'operation-logs',
  Teams: 'teams',
  TeamsNotificationsConfig: 'teams-notifications-config',
  TeamsPublicCache: 'teams-public-cache',
  TeamAlbums: 'team-albums',
  TeamGroups: 'team-groups',
  TeamTags: 'teams/{id}/tags',
  Users: 'users',
  UserNotificationLogs: 'user-notification-logs',
});
